export default function Error404WithoutHeaderFooter() {
  return <div>404 - Page Not Found (Without Header and Footer)</div>;
}
